export interface BudgetPeriodConstructor {
  startDate: ISODateString
  endDate: ISODateString
  expired: boolean
}

export class BudgetPeriod {
  readonly startDate: Date
  readonly endDate: Date
  readonly expired: boolean

  constructor(data: BudgetPeriodConstructor) {
    this.startDate = new Date(data.startDate)
    this.endDate = new Date(data.endDate)
    this.expired = data.expired
  }

  get isActive(): boolean {
    return !this.expired
  }

  // Leading word of the Budget Date cell ("Active" / "Expired")
  get statusLabel(): 'Active' | 'Expired' {
    return this.expired ? 'Expired' : 'Active'
  }
}
